import { render } from "./GalleryExperienceStudy.vue?vue&type=template&id=05439434&scoped=true"
import script from "./GalleryExperienceStudy.vue?vue&type=script&lang=js"
export * from "./GalleryExperienceStudy.vue?vue&type=script&lang=js"

import "./GalleryExperienceStudy.vue?vue&type=style&index=0&id=05439434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05439434"]])

export default __exports__